import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12.19 1.1a.5.5 0 0 0-.184.47c.484 3.148-.17 5.09-1.033 6.252-.76 1.025-1.71 1.485-2.297 1.632-.355-.4-.5-.73-.573-1.096-.068-.342-.076-.705-.086-1.207-.004-.2-.008-.422-.017-.674a.5.5 0 0 0-.658-.457c-.888.296-2.09 1.263-3.061 2.622C3.297 10.02 2.5 11.87 2.5 13.997 2.5 19.33 7.28 23 12 23c4.758 0 9.5-3.707 9.5-10.003 0-4.197-2.233-7.198-4.42-9.128a18 18 0 0 0-3.005-2.139 15 15 0 0 0-1.277-.653c-.2-.089-.42-.124-.607.023Z"
    }, null, -1)
  ]));
}
const brandSocialMediaTinder = { render };
export {
  brandSocialMediaTinder as default,
  render
};
//# sourceMappingURL=brand-social-media-tinder.svg.js.map
